import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { SessaoAtualProvider } from './services/providers/sessao-atual-provider/sessao-atual-provider';

import './assets/css/circular-loading.css'
import toast, { ToastBar, Toaster, useToasterStore } from 'react-hot-toast';


const HotToast = () => {

  const { toasts } = useToasterStore();

  const TOAST_LIMIT = 1

  useEffect(() => {
    toasts
      .filter((t) => t.visible) // Only consider visible toasts
      .filter((_, i) => i >= TOAST_LIMIT) // Is toast index over limit?
      .forEach((t) => toast.remove(t.id)); // Dismiss – Use toast.remove(t.id) for no exit animation
  }, [toasts]);

  return (
    <Toaster toastOptions={{
      position: 'top-center',
      duration: 3000
    }} containerStyle={{
      top: 16,
      left: 16,
      right: 16,
      bottom: 16
    }}>
      {(t) => (
        <ToastBar
          toast={t}
        >
          {({ icon, message }) => {
            return (
              <div onClick={() => toast.dismiss(t.id)} style={{ display: 'flex', height: '100%', width: '100%' }}>
                {icon}
                {message}
              </div>
            )
          }
          }
        </ToastBar>
      )}
    </Toaster>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <SessaoAtualProvider>
      <HotToast />
      <App />
    </SessaoAtualProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

